import { getCanvasFingerprint } from './canvas'
import { SHA256 } from './sha256'

export const getDeviceFingerprint = (options = {}) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  new Promise((resolve) => {
    try {
      const fingerprint = getCanvasFingerprint(options)
      const hashedFingerprint = SHA256(fingerprint)

      return resolve(hashedFingerprint)
    } catch (error) {
      return resolve(null)
    }
  })

export default getDeviceFingerprint
